import { GLOWApiClient as api } from "../apiClients/GLOWClient";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    appointmentsList: build.query<
      AppointmentsListApiResponse,
      AppointmentsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/`,
        params: {
          client: queryArg.client,
          end_time: queryArg.endTime,
          ordering: queryArg.ordering,
          salon: queryArg.salon,
          search: queryArg.search,
          service: queryArg.service,
          start_time: queryArg.startTime,
          status: queryArg.status,
          team_member: queryArg.teamMember,
        },
      }),
    }),
    appointmentsCreate: build.mutation<
      AppointmentsCreateApiResponse,
      AppointmentsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/`,
        method: "POST",
        body: queryArg.appointmentCreateRequest,
      }),
    }),
    appointmentsRetrieve: build.query<
      AppointmentsRetrieveApiResponse,
      AppointmentsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/${queryArg.appointmentId}/`,
      }),
    }),
    appointmentsUpdate: build.mutation<
      AppointmentsUpdateApiResponse,
      AppointmentsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/${queryArg.appointmentId}/`,
        method: "PUT",
        body: queryArg.appointmentUpdateRequest,
      }),
    }),
    appointmentsPartialUpdate: build.mutation<
      AppointmentsPartialUpdateApiResponse,
      AppointmentsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/${queryArg.appointmentId}/`,
        method: "PATCH",
        body: queryArg.patchedAppointmentUpdateRequest,
      }),
    }),
    appointmentsDestroy: build.mutation<
      AppointmentsDestroyApiResponse,
      AppointmentsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/${queryArg.appointmentId}/`,
        method: "DELETE",
      }),
    }),
    appointmentsAvailableSlotsRetrieve: build.query<
      AppointmentsAvailableSlotsRetrieveApiResponse,
      AppointmentsAvailableSlotsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/available_slots/`,
        params: {
          date: queryArg.date,
          service_id: queryArg.serviceId,
          team_member_id: queryArg.teamMemberId,
          exclude_appointment_id: queryArg.excludeAppointmentId,
        },
      }),
    }),
    appointmentsConsecutiveSlotsRetrieve: build.query<
      AppointmentsConsecutiveSlotsRetrieveApiResponse,
      AppointmentsConsecutiveSlotsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/consecutive_slots/`,
        params: {
          service1_id: queryArg.service1Id,
          team_member1_id: queryArg.teamMember1Id,
          service2_id: queryArg.service2Id,
          team_member2_id: queryArg.teamMember2Id,
          date: queryArg.date,
          buffer_minutes: queryArg.bufferMinutes,
        },
      }),
    }),
    appointmentsMultiConsecutiveSlotsCreate: build.mutation<
      AppointmentsMultiConsecutiveSlotsCreateApiResponse,
      AppointmentsMultiConsecutiveSlotsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/multi_consecutive_slots/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    appointmentsUpcomingRetrieve: build.query<
      AppointmentsUpcomingRetrieveApiResponse,
      AppointmentsUpcomingRetrieveApiArg
    >({
      query: () => ({ url: `/api/appointments/upcoming/` }),
    }),
    authAddclientCreate: build.mutation<
      AuthAddclientCreateApiResponse,
      AuthAddclientCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/addclient/`,
        method: "POST",
        body: queryArg.simpleClientRequest,
      }),
    }),
    authChangePasswordCreate: build.mutation<
      AuthChangePasswordCreateApiResponse,
      AuthChangePasswordCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/change-password/`,
        method: "POST",
        body: queryArg.changePasswordRequest,
      }),
    }),
    authLoginCreate: build.mutation<
      AuthLoginCreateApiResponse,
      AuthLoginCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/login/`,
        method: "POST",
        body: queryArg.loginRequest,
      }),
    }),
    authLoginClientCreate: build.mutation<
      AuthLoginClientCreateApiResponse,
      AuthLoginClientCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/login/client/`,
        method: "POST",
        body: queryArg.loginRequest,
      }),
    }),
    authLoginProfessionalResponsableCreate: build.mutation<
      AuthLoginProfessionalResponsableCreateApiResponse,
      AuthLoginProfessionalResponsableCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/login/professional-responsable/`,
        method: "POST",
        body: queryArg.loginRequest,
      }),
    }),
    authLogoutCreate: build.mutation<
      AuthLogoutCreateApiResponse,
      AuthLogoutCreateApiArg
    >({
      query: () => ({ url: `/api/auth/logout/`, method: "POST" }),
    }),
    authPasswordResetCreate: build.mutation<
      AuthPasswordResetCreateApiResponse,
      AuthPasswordResetCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/password-reset/`,
        method: "POST",
        body: queryArg.requestPasswordResetRequest,
      }),
    }),
    authPermissionsRetrieve: build.query<
      AuthPermissionsRetrieveApiResponse,
      AuthPermissionsRetrieveApiArg
    >({
      query: () => ({ url: `/api/auth/permissions/` }),
    }),
    authProfileRetrieve: build.query<
      AuthProfileRetrieveApiResponse,
      AuthProfileRetrieveApiArg
    >({
      query: () => ({ url: `/api/auth/profile/` }),
    }),
    authProfileUpdate: build.mutation<
      AuthProfileUpdateApiResponse,
      AuthProfileUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/profile/`,
        method: "PUT",
        body: queryArg.userRequest,
      }),
    }),
    authRegisterCreate: build.mutation<
      AuthRegisterCreateApiResponse,
      AuthRegisterCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/register/`,
        method: "POST",
        body: queryArg.registerRequest,
      }),
    }),
    authRegisterClientCreate: build.mutation<
      AuthRegisterClientCreateApiResponse,
      AuthRegisterClientCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/register/client/`,
        method: "POST",
        body: queryArg.registerRequest,
      }),
    }),
    authRegisterProfessionalResponsableCreate: build.mutation<
      AuthRegisterProfessionalResponsableCreateApiResponse,
      AuthRegisterProfessionalResponsableCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/register/professional-responsable/`,
        method: "POST",
        body: queryArg.registerRequest,
      }),
    }),
    authResetPasswordCreate: build.mutation<
      AuthResetPasswordCreateApiResponse,
      AuthResetPasswordCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/reset-password/${queryArg.token}/`,
        method: "POST",
        body: queryArg.resetPasswordRequest,
      }),
    }),
    authTokenCreate: build.mutation<
      AuthTokenCreateApiResponse,
      AuthTokenCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/token/`,
        method: "POST",
        body: queryArg.customTokenObtainPairRequest,
      }),
    }),
    authTokenRefreshCreate: build.mutation<
      AuthTokenRefreshCreateApiResponse,
      AuthTokenRefreshCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/token/refresh/`,
        method: "POST",
        body: queryArg.tokenRefreshRequest,
      }),
    }),
    categoriesList: build.query<
      CategoriesListApiResponse,
      CategoriesListApiArg
    >({
      query: () => ({ url: `/api/categories/` }),
    }),
    categoriesCreate: build.mutation<
      CategoriesCreateApiResponse,
      CategoriesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/categories/`,
        method: "POST",
        body: queryArg.categoryCreateRequest,
      }),
    }),
    categoriesRetrieve: build.query<
      CategoriesRetrieveApiResponse,
      CategoriesRetrieveApiArg
    >({
      query: (queryArg) => ({ url: `/api/categories/${queryArg.categoryId}/` }),
    }),
    categoriesPartialUpdate: build.mutation<
      CategoriesPartialUpdateApiResponse,
      CategoriesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/categories/${queryArg.categoryId}/`,
        method: "PATCH",
      }),
    }),
    categoriesDestroy: build.mutation<
      CategoriesDestroyApiResponse,
      CategoriesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/categories/${queryArg.categoryId}/`,
        method: "DELETE",
      }),
    }),
    categoriesDefaultRetrieve: build.query<
      CategoriesDefaultRetrieveApiResponse,
      CategoriesDefaultRetrieveApiArg
    >({
      query: () => ({ url: `/api/categories/default/` }),
    }),
    dashboardGlobalRetrieve: build.query<
      DashboardGlobalRetrieveApiResponse,
      DashboardGlobalRetrieveApiArg
    >({
      query: () => ({ url: `/api/dashboard/global/` }),
    }),
    dashboardMetricsList: build.query<
      DashboardMetricsListApiResponse,
      DashboardMetricsListApiArg
    >({
      query: () => ({ url: `/api/dashboard/metrics/` }),
    }),
    dashboardMetricsCreate: build.mutation<
      DashboardMetricsCreateApiResponse,
      DashboardMetricsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dashboard/metrics/`,
        method: "POST",
        body: queryArg.dashboardMetricRequest,
      }),
    }),
    dashboardMetricsRetrieve: build.query<
      DashboardMetricsRetrieveApiResponse,
      DashboardMetricsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dashboard/metrics/${queryArg.metricId}/`,
      }),
    }),
    dashboardMetricsUpdate: build.mutation<
      DashboardMetricsUpdateApiResponse,
      DashboardMetricsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dashboard/metrics/${queryArg.metricId}/`,
        method: "PUT",
        body: queryArg.dashboardMetricRequest,
      }),
    }),
    dashboardMetricsPartialUpdate: build.mutation<
      DashboardMetricsPartialUpdateApiResponse,
      DashboardMetricsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dashboard/metrics/${queryArg.metricId}/`,
        method: "PATCH",
        body: queryArg.patchedDashboardMetricRequest,
      }),
    }),
    dashboardMetricsDestroy: build.mutation<
      DashboardMetricsDestroyApiResponse,
      DashboardMetricsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dashboard/metrics/${queryArg.metricId}/`,
        method: "DELETE",
      }),
    }),
    dashboardSalonRetrieve: build.query<
      DashboardSalonRetrieveApiResponse,
      DashboardSalonRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/dashboard/salon/${queryArg.salonId}/`,
      }),
    }),
    locationsList: build.query<LocationsListApiResponse, LocationsListApiArg>({
      query: () => ({ url: `/api/locations/` }),
    }),
    locationsCreate: build.mutation<
      LocationsCreateApiResponse,
      LocationsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/`,
        method: "POST",
        body: queryArg.locationCreateRequest,
      }),
    }),
    locationsRetrieve: build.query<
      LocationsRetrieveApiResponse,
      LocationsRetrieveApiArg
    >({
      query: (queryArg) => ({ url: `/api/locations/${queryArg.locationId}/` }),
    }),
    locationsPartialUpdate: build.mutation<
      LocationsPartialUpdateApiResponse,
      LocationsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/`,
        method: "PATCH",
        body: queryArg.patchedLocationUpdateRequest,
      }),
    }),
    locationsDestroy: build.mutation<
      LocationsDestroyApiResponse,
      LocationsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/locations/${queryArg.locationId}/`,
        method: "DELETE",
      }),
    }),
    salonsList: build.query<SalonsListApiResponse, SalonsListApiArg>({
      query: (queryArg) => {
        const paramsArg = (queryArg || {}) as Exclude<SalonsListApiArg, void>;
        return {
          url: `/api/salons/`,
          params: {
            ordering: paramsArg.ordering,
            owner: paramsArg.owner,
            search: paramsArg.search,
            language: paramsArg.language,
          },
        };
      },
    }),
    salonsCreate: build.mutation<SalonsCreateApiResponse, SalonsCreateApiArg>({
      query: (queryArg) => ({
        url: `/api/salons/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    salonsRetrieve: build.query<
      SalonsRetrieveApiResponse,
      SalonsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/salons/${queryArg.salonId}/`,
        params: { language: queryArg.language },
      }),
    }),
    salonsPartialUpdate: build.mutation<
      SalonsPartialUpdateApiResponse,
      SalonsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/salons/${queryArg.salonId}/`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    salonsDestroy: build.mutation<
      SalonsDestroyApiResponse,
      SalonsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/salons/${queryArg.salonId}/`,
        method: "DELETE",
      }),
    }),
    salonsCategoriesList: build.query<
      SalonsCategoriesListApiResponse,
      SalonsCategoriesListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/salons/${queryArg.salonId}/categories/`,
        params: {
          ordering: queryArg.ordering,
          owner: queryArg.owner,
          search: queryArg.search,
        },
      }),
    }),
    salonsMySalonsRetrieve: build.query<
      SalonsMySalonsRetrieveApiResponse,
      SalonsMySalonsRetrieveApiArg
    >({
      query: (queryArg) => {
        const paramsArg = (queryArg || {}) as Exclude<SalonsMySalonsRetrieveApiArg, void>;
        return {
          url: `/api/salons/my_salons/`,
          params: { language: paramsArg.language },
        };
      },
    }),
    salonsSearchSalonsList: build.query<
      SalonsSearchSalonsListApiResponse,
      SalonsSearchSalonsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/salons/search-salons/`,
        params: {
          address: queryArg.address,
          distance: queryArg.distance,
          latitude: queryArg.latitude,
          location: queryArg.location,
          longitude: queryArg.longitude,
          ordering: queryArg.ordering,
          owner: queryArg.owner,
          search: queryArg.search,
          service_id: queryArg.serviceId,
          // Important: backend expects category_id or categoryId
          category_id: (queryArg as any).categoryId ?? (queryArg as any).category_id,
        },
      }),
    }),
    schedulesBreaksList: build.query<
      SchedulesBreaksListApiResponse,
      SchedulesBreaksListApiArg
    >({
      query: () => ({ url: `/api/schedules/breaks/` }),
    }),
    schedulesBreaksCreate: build.mutation<
      SchedulesBreaksCreateApiResponse,
      SchedulesBreaksCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/`,
        method: "POST",
        body: queryArg.breakRequest,
      }),
    }),
    schedulesBreaksRetrieve: build.query<
      SchedulesBreaksRetrieveApiResponse,
      SchedulesBreaksRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/${queryArg.breakId}/`,
      }),
    }),
    schedulesBreaksUpdate: build.mutation<
      SchedulesBreaksUpdateApiResponse,
      SchedulesBreaksUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/${queryArg.breakId}/`,
        method: "PUT",
        body: queryArg.breakRequest,
      }),
    }),
    schedulesBreaksPartialUpdate: build.mutation<
      SchedulesBreaksPartialUpdateApiResponse,
      SchedulesBreaksPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/${queryArg.breakId}/`,
        method: "PATCH",
        body: queryArg.patchedBreakRequest,
      }),
    }),
    schedulesBreaksDestroy: build.mutation<
      SchedulesBreaksDestroyApiResponse,
      SchedulesBreaksDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/${queryArg.breakId}/`,
        method: "DELETE",
      }),
    }),
    schedulesBreaksByDayRetrieve: build.query<
      SchedulesBreaksByDayRetrieveApiResponse,
      SchedulesBreaksByDayRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/by_day/`,
        params: {
          day: queryArg.day,
        },
      }),
    }),
    schedulesBreaksBySalonRetrieve: build.query<
      SchedulesBreaksBySalonRetrieveApiResponse,
      SchedulesBreaksBySalonRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/by_salon/`,
        params: {
          salon_id: queryArg.salonId,
        },
      }),
    }),
    schedulesBreaksByTeamMemberRetrieve: build.query<
      SchedulesBreaksByTeamMemberRetrieveApiResponse,
      SchedulesBreaksByTeamMemberRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/breaks/by_team_member/`,
        params: {
          team_member_id: queryArg.teamMemberId,
        },
      }),
    }),
    schedulesSchedulesList: build.query<
      SchedulesSchedulesListApiResponse,
      SchedulesSchedulesListApiArg
    >({
      query: () => ({ url: `/api/schedules/schedules/` }),
    }),
    schedulesSchedulesCreate: build.mutation<
      SchedulesSchedulesCreateApiResponse,
      SchedulesSchedulesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/`,
        method: "POST",
        body: queryArg.scheduleRequest,
      }),
    }),
    schedulesSchedulesRetrieve: build.query<
      SchedulesSchedulesRetrieveApiResponse,
      SchedulesSchedulesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/${queryArg.scheduleId}/`,
      }),
    }),
    schedulesSchedulesUpdate: build.mutation<
      SchedulesSchedulesUpdateApiResponse,
      SchedulesSchedulesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/${queryArg.scheduleId}/`,
        method: "PUT",
        body: queryArg.scheduleRequest,
      }),
    }),
    schedulesSchedulesPartialUpdate: build.mutation<
      SchedulesSchedulesPartialUpdateApiResponse,
      SchedulesSchedulesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/${queryArg.scheduleId}/`,
        method: "PATCH",
        body: queryArg.patchedScheduleRequest,
      }),
    }),
    schedulesSchedulesDestroy: build.mutation<
      SchedulesSchedulesDestroyApiResponse,
      SchedulesSchedulesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/${queryArg.scheduleId}/`,
        method: "DELETE",
      }),
    }),
    schedulesSchedulesByDayRetrieve: build.query<
      SchedulesSchedulesByDayRetrieveApiResponse,
      SchedulesSchedulesByDayRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/by_day/`,
        params: {
          day: queryArg.day,
        },
      }),
    }),
    schedulesSchedulesBySalonRetrieve: build.query<
      SchedulesSchedulesBySalonRetrieveApiResponse,
      SchedulesSchedulesBySalonRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/by_salon/`,
        params: {
          salon_id: queryArg.salonId,
        },
      }),
    }),
    schedulesSchedulesByTeamMemberRetrieve: build.query<
      SchedulesSchedulesByTeamMemberRetrieveApiResponse,
      SchedulesSchedulesByTeamMemberRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/schedules/schedules/by_team_member/`,
        params: {
          team_member_id: queryArg.teamMemberId,
        },
      }),
    }),
    servicesList: build.query<ServicesListApiResponse, ServicesListApiArg>({
      query: (queryArg) => ({
        url: `/api/services/`,
        params: {
          category: queryArg.category,
          ordering: queryArg.ordering,
          salon: queryArg.salon,
          search: queryArg.search,
        },
      }),
    }),
    servicesCreate: build.mutation<
      ServicesCreateApiResponse,
      ServicesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/services/`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["All"],
    }),
    servicesRetrieve: build.query<
      ServicesRetrieveApiResponse,
      ServicesRetrieveApiArg
    >({
      query: (queryArg) => ({ url: `/api/services/${queryArg.serviceId}/` }),
    }),
    servicesPartialUpdate: build.mutation<
      ServicesPartialUpdateApiResponse,
      ServicesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/services/${queryArg.serviceId}/`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["All"],
    }),
    servicesDestroy: build.mutation<
      ServicesDestroyApiResponse,
      ServicesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/services/${queryArg.serviceId}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["All"],
    }),
    servicesByCategoryList: build.query<
      ServicesByCategoryListApiResponse,
      ServicesByCategoryListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/services/by-category/`,
        params: {
          category: queryArg.category,
          ordering: queryArg.ordering,
          salon: queryArg.salon,
          salon_id: queryArg.salonId,
          search: queryArg.search,
        },
      }),
    }),
    servicesPublicPublicAllServicesList: build.query<
      ServicesPublicPublicAllServicesListApiResponse,
      ServicesPublicPublicAllServicesListApiArg
    >({
      query: () => ({ url: `/api/services/public/public_all_services/` }),
    }),
    servicesPublicSalonList: build.query<
      ServicesPublicSalonListApiResponse,
      ServicesPublicSalonListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/services/public/salon/${queryArg.salonId}/`,
        params: {
          language: queryArg.language,
        },
      }),
      providesTags: ["All"],
    }),
    servicesSalonList: build.query<
      ServicesSalonListApiResponse,
      ServicesSalonListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/services/salon/${queryArg.salonId}/`,
        params: {
          category: queryArg.category,
          ordering: queryArg.ordering,
          salon: queryArg.salon,
          search: queryArg.search,
          language: queryArg.language,
        },
      }),
      providesTags: ["All"],
    }),
    teamsTeamMembersList: build.query<
      TeamsTeamMembersListApiResponse,
      TeamsTeamMembersListApiArg
    >({
      query: () => ({ url: `/api/teams/team-members/` }),
    }),
    teamsTeamMembersCreate: build.mutation<
      TeamsTeamMembersCreateApiResponse,
      TeamsTeamMembersCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/`,
        method: "POST",
        body: queryArg.teamMemberRequest,
      }),
    }),
    teamsTeamMembersRetrieve: build.query<
      TeamsTeamMembersRetrieveApiResponse,
      TeamsTeamMembersRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/${queryArg.teamMemberId}/`,
      }),
    }),
    teamsTeamMembersUpdate: build.mutation<
      TeamsTeamMembersUpdateApiResponse,
      TeamsTeamMembersUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/${queryArg.teamMemberId}/`,
        method: "PUT",
        body: queryArg.teamMemberRequest,
      }),
    }),
    teamsTeamMembersPartialUpdate: build.mutation<
      TeamsTeamMembersPartialUpdateApiResponse,
      TeamsTeamMembersPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/${queryArg.teamMemberId}/`,
        method: "PATCH",
        body: queryArg.patchedTeamMemberRequest,
      }),
    }),
    teamsTeamMembersDestroy: build.mutation<
      TeamsTeamMembersDestroyApiResponse,
      TeamsTeamMembersDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/${queryArg.teamMemberId}/`,
        method: "DELETE",
      }),
    }),
    teamsTeamMembersByServiceSalonRetrieve: build.query<
      TeamsTeamMembersByServiceSalonRetrieveApiResponse,
      TeamsTeamMembersByServiceSalonRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/by-service-salon/`,
        params: {
          salon: queryArg.salon,
          service: queryArg.service,
        },
      }),
    }),
    teamsTeamMembersByOwnerRetrieve: build.query<
      TeamsTeamMembersByOwnerRetrieveApiResponse,
      TeamsTeamMembersByOwnerRetrieveApiArg
    >({
      query: () => ({ url: `/api/teams/team-members/by_owner/` }),
    }),
    teamsTeamMembersMemberAppointmentsRetrieve: build.query<
      TeamsTeamMembersMemberAppointmentsRetrieveApiResponse,
      TeamsTeamMembersMemberAppointmentsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/member_appointments/`,
        params: {
          end_date: queryArg.endDate,
          start_date: queryArg.startDate,
          status: queryArg.status,
          team_member_id: queryArg.teamMemberId,
        },
      }),
    }),
    teamsTeamMembersMemberSalonsRetrieve: build.query<
      TeamsTeamMembersMemberSalonsRetrieveApiResponse,
      TeamsTeamMembersMemberSalonsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/member_salons/`,
        params: {
          team_member_id: queryArg.teamMemberId,
        },
      }),
    }),
    teamsTeamMembersSalonMembersRetrieve: build.query<
      TeamsTeamMembersSalonMembersRetrieveApiResponse,
      TeamsTeamMembersSalonMembersRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/salon_members/`,
        params: {
          salon: queryArg.salon,
        },
      }),
    }),
    teamsTeamMembersUserServicesRetrieve: build.query<
      TeamsTeamMembersUserServicesRetrieveApiResponse,
      TeamsTeamMembersUserServicesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/user_services/`,
        params: {
          user_id: queryArg.userId,
        },
      }),
    }),
    teamsTeamMembersUserTeamsRetrieve: build.query<
      TeamsTeamMembersUserTeamsRetrieveApiResponse,
      TeamsTeamMembersUserTeamsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/team-members/user_teams/`,
        params: {
          user_id: queryArg.userId,
        },
      }),
    }),
    teamsTeamsList: build.query<
      TeamsTeamsListApiResponse,
      TeamsTeamsListApiArg
    >({
      query: () => ({ url: `/api/teams/teams/` }),
    }),
    teamsTeamsCreate: build.mutation<
      TeamsTeamsCreateApiResponse,
      TeamsTeamsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/teams/`,
        method: "POST",
        body: queryArg.teamRequest,
      }),
    }),
    teamsTeamsRetrieve: build.query<
      TeamsTeamsRetrieveApiResponse,
      TeamsTeamsRetrieveApiArg
    >({
      query: (queryArg) => ({ url: `/api/teams/teams/${queryArg.teamId}/` }),
    }),
    teamsTeamsUpdate: build.mutation<
      TeamsTeamsUpdateApiResponse,
      TeamsTeamsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/teams/${queryArg.teamId}/`,
        method: "PUT",
        body: queryArg.teamRequest,
      }),
    }),
    teamsTeamsPartialUpdate: build.mutation<
      TeamsTeamsPartialUpdateApiResponse,
      TeamsTeamsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/teams/${queryArg.teamId}/`,
        method: "PATCH",
        body: queryArg.patchedTeamRequest,
      }),
    }),
    teamsTeamsDestroy: build.mutation<
      TeamsTeamsDestroyApiResponse,
      TeamsTeamsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/teams/${queryArg.teamId}/`,
        method: "DELETE",
      }),
    }),
    teamsTeamsMembersRetrieve: build.query<
      TeamsTeamsMembersRetrieveApiResponse,
      TeamsTeamsMembersRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/teams/teams/${queryArg.teamId}/members/`,
      }),
    }),
    usersList: build.query<UsersListApiResponse, UsersListApiArg>({
      query: (queryArg) => ({
        url: `/api/users/`,
        params: {
          role: queryArg.role,
        },
      }),
    }),
    usersCreate: build.mutation<UsersCreateApiResponse, UsersCreateApiArg>({
      query: (queryArg) => ({
        url: `/api/users/`,
        method: "POST",
        body: queryArg.userCreateRequest,
      }),
    }),
    usersRetrieve: build.query<UsersRetrieveApiResponse, UsersRetrieveApiArg>({
      query: (queryArg) => ({ url: `/api/users/${queryArg.id}/` }),
    }),
    usersPartialUpdate: build.mutation<
      UsersPartialUpdateApiResponse,
      UsersPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedUserRequest,
      }),
    }),
    usersDestroy: build.mutation<UsersDestroyApiResponse, UsersDestroyApiArg>({
      query: (queryArg) => ({
        url: `/api/users/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    usersClientsList: build.query<
      UsersClientsListApiResponse,
      UsersClientsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/clients/`,
        params: {
          email: queryArg.email,
          first_name: queryArg.firstName,
          last_name: queryArg.lastName,
          phone: queryArg.phone,
          search: queryArg.search,
        },
      }),
    }),
    usersClientsByOwnerList: build.query<
      UsersClientsByOwnerListApiResponse,
      UsersClientsByOwnerListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/clients/by-owner/`,
        params: {
          email: queryArg.email,
          first_name: queryArg.firstName,
          last_name: queryArg.lastName,
          owner_id: queryArg.ownerId,
          phone: queryArg.phone,
          search: queryArg.search,
        },
      }),
    }),
    usersClientsBySalonList: build.query<
      UsersClientsBySalonListApiResponse,
      UsersClientsBySalonListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/clients/by-salon/`,
        params: {
          email: queryArg.email,
          first_name: queryArg.firstName,
          last_name: queryArg.lastName,
          phone: queryArg.phone,
          salon_id: queryArg.salonId,
          search: queryArg.search,
        },
      }),
    }),
    usersNotifyClientsCreate: build.mutation<
      UsersNotifyClientsCreateApiResponse,
      UsersNotifyClientsCreateApiArg
    >({
      query: (queryArg) => {
        const formData = new FormData();
        formData.append('client_ids', JSON.stringify(queryArg.clientIds));
        formData.append('delivery_modes', JSON.stringify(queryArg.deliveryModes));
        if ((queryArg as any).salonId != null && (queryArg as any).salonId !== '') formData.append('salon_id', String((queryArg as any).salonId));
        if (queryArg.emailSubject) formData.append('email_subject', queryArg.emailSubject);
        if (queryArg.emailContent) formData.append('email_content', queryArg.emailContent);
        if (queryArg.notificationTitle) formData.append('notification_title', queryArg.notificationTitle);
        if (queryArg.notificationMessage) formData.append('notification_message', queryArg.notificationMessage);
        if (queryArg.photo) formData.append('photo', queryArg.photo);

        return {
          url: `/api/users/notify-clients/`,
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as injectedRtkApi };
export type AppointmentsListApiResponse =
  /** status 200  */ AppointmentListRead[];
export type AppointmentsListApiArg = {
  client?: number;
  endTime?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  salon?: number;
  /** A search term. */
  search?: string;
  service?: number;
  startTime?: string;
  /** * `pending` - Pending
   * `confirmed` - Confirmed
   * `cancelled` - Cancelled
   * `completed` - Completed */
  status?: "cancelled" | "completed" | "confirmed" | "pending";
  teamMember?: number;
};
export type AppointmentsCreateApiResponse =
  /** status 201  */ AppointmentCreate;
export type AppointmentsCreateApiArg = {
  appointmentCreateRequest: AppointmentCreateRequest;
};
export type AppointmentsRetrieveApiResponse =
  /** status 200  */ AppointmentListRead;
export type AppointmentsRetrieveApiArg = {
  /** A unique integer value identifying this Appointment. */
  appointmentId: number;
};
export type AppointmentsUpdateApiResponse =
  /** status 200  */ AppointmentUpdate;
export type AppointmentsUpdateApiArg = {
  /** A unique integer value identifying this Appointment. */
  appointmentId: number;
  appointmentUpdateRequest: AppointmentUpdateRequest;
};
export type AppointmentsPartialUpdateApiResponse =
  /** status 200  */ AppointmentUpdate;
export type AppointmentsPartialUpdateApiArg = {
  /** A unique integer value identifying this Appointment. */
  appointmentId: number;
  patchedAppointmentUpdateRequest: PatchedAppointmentUpdateRequest;
};
export type AppointmentsDestroyApiResponse = unknown;
export type AppointmentsDestroyApiArg = {
  /** A unique integer value identifying this Appointment. */
  appointmentId: number;
};
export type AppointmentsAvailableSlotsRetrieveApiResponse =
  /** status 200  */ any;
export type AppointmentsAvailableSlotsRetrieveApiArg = {
  /** Date for which to find available slots (format: YYYY-MM-DD) (optional - if not provided, uses current date) */
  date?: string;
  /** ID of the service to book */
  serviceId: number;
  /** ID of the team member providing the service (optional - if not provided, shows availabilities for all team members who can provide the service) */
  teamMemberId?: number;
  /** Current appointment to ignore while editing a salon proposal */
  excludeAppointmentId?: number;
};
export type AppointmentsConsecutiveSlotsRetrieveApiResponse =
  /** status 200  */ any;
export type AppointmentsConsecutiveSlotsRetrieveApiArg = {
  /** ID of the first service */
  service1Id: number;
  /** ID of the team member for the first service */
  teamMember1Id: number;
  /** ID of the second service */
  service2Id: number;
  /** ID of the team member for the second service */
  teamMember2Id: number;
  /** Date for which to find consecutive slots (format: YYYY-MM-DD) (optional - if not provided, uses current date) */
  date?: string;
  /** Buffer time between services in minutes (default: 0) */
  bufferMinutes?: number;
};
export type AppointmentsMultiConsecutiveSlotsCreateApiResponse = any;
export type AppointmentsMultiConsecutiveSlotsCreateApiArg = {
  body: {
    date?: string;
    buffer_minutes?: number;
    slot_interval_minutes?: number;
    allow_next_slot?: boolean;
    max_gap_minutes?: number;
    services: { service_id: number; team_member_id: number }[];
  };
};
export type AppointmentsUpcomingRetrieveApiResponse =
  /** status 200  */ AppointmentListRead;
export type AppointmentsUpcomingRetrieveApiArg = void;
export type AuthAddclientCreateApiResponse =
  /** status 201  */ SimpleClientRead;
export type AuthAddclientCreateApiArg = {
  simpleClientRequest: SimpleClientRequest;
};
export type AuthChangePasswordCreateApiResponse = unknown;
export type AuthChangePasswordCreateApiArg = {
  changePasswordRequest: ChangePasswordRequest;
};
export type AuthLoginCreateApiResponse = unknown;
export type AuthLoginCreateApiArg = {
  loginRequest: LoginRequestWrite;
};
export type AuthLoginClientCreateApiResponse = unknown;
export type AuthLoginClientCreateApiArg = {
  loginRequest: LoginRequestWrite;
};
export type AuthLoginProfessionalResponsableCreateApiResponse = unknown;
export type AuthLoginProfessionalResponsableCreateApiArg = {
  loginRequest: LoginRequestWrite;
};
export type AuthLogoutCreateApiResponse = unknown;
export type AuthLogoutCreateApiArg = void;
export type AuthPasswordResetCreateApiResponse = unknown;
export type AuthPasswordResetCreateApiArg = {
  requestPasswordResetRequest: RequestPasswordResetRequest;
};
export type AuthPermissionsRetrieveApiResponse =
  /** status 200  */ UserPermissions;
export type AuthPermissionsRetrieveApiArg = void;
export type AuthProfileRetrieveApiResponse = /** status 200  */ UserRead;
export type AuthProfileRetrieveApiArg = void;
export type AuthProfileUpdateApiResponse = /** status 200  */ UserRead;
export type AuthProfileUpdateApiArg = {
  userRequest: UserRequest;
};
export type AuthRegisterCreateApiResponse = unknown;
export type AuthRegisterCreateApiArg = {
  registerRequest: RegisterRequestWrite;
};
export type AuthRegisterClientCreateApiResponse = unknown;
export type AuthRegisterClientCreateApiArg = {
  registerRequest: RegisterRequestWrite;
};
export type AuthRegisterProfessionalResponsableCreateApiResponse = unknown;
export type AuthRegisterProfessionalResponsableCreateApiArg = {
  registerRequest: RegisterRequestWrite;
};
export type AuthResetPasswordCreateApiResponse = unknown;
export type AuthResetPasswordCreateApiArg = {
  token: string;
  resetPasswordRequest: ResetPasswordRequest;
};
export type AuthTokenCreateApiResponse = unknown;
export type AuthTokenCreateApiArg = {
  customTokenObtainPairRequest: CustomTokenObtainPairRequestWrite;
};
export type AuthTokenRefreshCreateApiResponse =
  /** status 200  */ TokenRefreshRead;
export type AuthTokenRefreshCreateApiArg = {
  tokenRefreshRequest: TokenRefreshRequestWrite;
};
export type CategoriesListApiResponse = /** status 200  */ CategoryRead[];
export type CategoriesListApiArg = void;
export type CategoriesCreateApiResponse = /** status 201  */ CategoryRead;
export type CategoriesCreateApiArg = {
  categoryCreateRequest: CategoryCreateRequest;
};
export type CategoriesRetrieveApiResponse = /** status 200  */ CategoryRead;
export type CategoriesRetrieveApiArg = {
  /** A unique integer value identifying this category. */
  categoryId: number;
};
export type CategoriesPartialUpdateApiResponse = unknown;
export type CategoriesPartialUpdateApiArg = {
  /** A unique integer value identifying this category. */
  categoryId: number;
};
export type CategoriesDestroyApiResponse = unknown;
export type CategoriesDestroyApiArg = {
  /** A unique integer value identifying this category. */
  categoryId: number;
};
export type CategoriesDefaultRetrieveApiResponse = /** status 200  */ {
  success?: string;
};
export type CategoriesDefaultRetrieveApiArg = void;
export type DashboardGlobalRetrieveApiResponse =
  /** status 200  */ GlobalDashboard;
export type DashboardGlobalRetrieveApiArg = void;
export type DashboardMetricsListApiResponse =
  /** status 200  */ DashboardMetricRead[];
export type DashboardMetricsListApiArg = void;
export type DashboardMetricsCreateApiResponse =
  /** status 201  */ DashboardMetricRead;
export type DashboardMetricsCreateApiArg = {
  dashboardMetricRequest: DashboardMetricRequest;
};
export type DashboardMetricsRetrieveApiResponse =
  /** status 200  */ DashboardMetricRead;
export type DashboardMetricsRetrieveApiArg = {
  /** A unique integer value identifying this dashboard metric. */
  metricId: number;
};
export type DashboardMetricsUpdateApiResponse =
  /** status 200  */ DashboardMetricRead;
export type DashboardMetricsUpdateApiArg = {
  /** A unique integer value identifying this dashboard metric. */
  metricId: number;
  dashboardMetricRequest: DashboardMetricRequest;
};
export type DashboardMetricsPartialUpdateApiResponse =
  /** status 200  */ DashboardMetricRead;
export type DashboardMetricsPartialUpdateApiArg = {
  /** A unique integer value identifying this dashboard metric. */
  metricId: number;
  patchedDashboardMetricRequest: PatchedDashboardMetricRequest;
};
export type DashboardMetricsDestroyApiResponse = unknown;
export type DashboardMetricsDestroyApiArg = {
  /** A unique integer value identifying this dashboard metric. */
  metricId: number;
};
export type DashboardSalonRetrieveApiResponse =
  /** status 200  */ SalonDashboardRead;
export type DashboardSalonRetrieveApiArg = {
  salonId: number;
};
export type LocationsListApiResponse = /** status 200  */ LocationRead[];
export type LocationsListApiArg = void;
export type LocationsCreateApiResponse = /** status 201  */ LocationCreate;
export type LocationsCreateApiArg = {
  locationCreateRequest: LocationCreateRequest;
};
export type LocationsRetrieveApiResponse = /** status 200  */ LocationRead;
export type LocationsRetrieveApiArg = {
  /** A unique integer value identifying this location. */
  locationId: number;
};
export type LocationsPartialUpdateApiResponse =
  /** status 200  */ LocationUpdate;
export type LocationsPartialUpdateApiArg = {
  /** A unique integer value identifying this location. */
  locationId: number;
  patchedLocationUpdateRequest: PatchedLocationUpdateRequest;
};
export type LocationsDestroyApiResponse = unknown;
export type LocationsDestroyApiArg = {
  /** A unique integer value identifying this location. */
  locationId: number;
};
export type SalonsListApiResponse = /** status 200  */ SalonRead[];
export type SalonsListApiArg = void | {
  /** Which field to use when ordering the results. */
  ordering?: string;
  owner?: number;
  /** A search term. */
  search?: string;
  language?: string;
};
export type SalonsCreateApiResponse = /** status 201  */ SalonRead;
export type SalonsCreateApiArg = {
  body: {
    name: string;
    description?: string;
    address: string;
    phone?: string;
    email?: string;
    /** JSON string for multipart form data. Example: {"lundi":{"ouverture":"09:00","fermeture":"18:00"}} */
    opening_hours?: string;
    owner?: number;
    /** Single photo upload. Use this OR photos[] for multiple uploads. */
    photo?: Blob;
    /** Caption for single photo upload */
    photo_caption?: string;
    /** Multiple photo uploads. Use this OR photo for single upload. */
    "photos[]"?: Blob[];
    /** JSON array of captions for multiple photos. Example: ["First photo", "Second photo"] */
    photo_captions?: string;
    /** Whether the first photo should be primary. Default is true for new salons. */
    is_primary?: boolean;
    /** Latitude coordinate for salon location */
    latitude?: number;
    /** Longitude coordinate for salon location */
    longitude?: number;
  };
};
export type SalonsRetrieveApiResponse = /** status 200  */ SalonRead;
export type SalonsRetrieveApiArg = {
  /** A unique integer value identifying this salon. */
  salonId: number;
  language?: string;
};
export type SalonsPartialUpdateApiResponse = /** status 200  */ SalonRead;
export type SalonsPartialUpdateApiArg = {
  /** A unique integer value identifying this salon. */
  salonId: number;
  body: {
    /** Optional */
    name?: string;
    /** Optional */
    description?: string;
    /** Optional */
    address?: string;
    /** Optional */
    phone?: string;
    /** Optional */
    email?: string;
    /** Optional. JSON string for multipart form data. Example: {"lundi":{"ouverture":"09:00","fermeture":"18:00"}} */
    opening_hours?: string;
    /** Optional */
    owner?: number;
    /** Optional. Single photo upload. Use this OR photos[] for multiple uploads. */
    photo?: Blob;
    /** Optional. Caption for single photo upload */
    photo_caption?: string;
    /** Optional. Multiple photo uploads. Use this OR photo for single upload. */
    "photos[]"?: Blob[];
    /** Optional. JSON array of captions for multiple photos. Example: ["First photo", "Second photo"] */
    photo_captions?: string;
    /** Optional. Whether the first photo should be primary. */
    is_primary?: boolean;
    /** Optional, latitude coordinate for salon location */
    latitude?: number;
    /** Optional, longitude coordinate for salon location */
    longitude?: number;
  };
};
export type SalonsDestroyApiResponse = /** status 200  */ {
  success?: string;
};
export type SalonsDestroyApiArg = {
  /** A unique integer value identifying this salon. */
  salonId: number;
};
export type SalonsCategoriesListApiResponse = /** status 200  */ CategoryRead[];
export type SalonsCategoriesListApiArg = {
  /** Which field to use when ordering the results. */
  ordering?: string;
  owner?: number;
  /** A unique integer value identifying this salon. */
  salonId: number;
  /** A search term. */
  search?: string;
};
export type SalonsMySalonsRetrieveApiResponse = /** status 200  */ SalonRead;
export type SalonsMySalonsRetrieveApiArg = void | {
  language?: string;
};
export type SalonsSearchSalonsListApiResponse = /** status 200  */ SalonRead[];
export type SalonsSearchSalonsListApiArg = {
  /** Legacy parameter for address (use location instead) */
  address?: string;
  /** Search radius in kilometers */
  distance?: number;
  /** Latitude of the search location (optional if location is provided) */
  latitude?: number;
  /** Location name, city, or address to search around (primary search parameter) */
  location?: string;
  /** Longitude of the search location (optional if location is provided) */
  longitude?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  owner?: number;
  /** A search term. */
  search?: string;
  /** ID of the service to filter salons by */
  serviceId?: number;
};
export type SchedulesBreaksListApiResponse =
  /** status 200  */ BreakDetailRead[];
export type SchedulesBreaksListApiArg = void;
export type SchedulesBreaksCreateApiResponse = /** status 201  */ BreakRead;
export type SchedulesBreaksCreateApiArg = {
  breakRequest: BreakRequest;
};
export type SchedulesBreaksRetrieveApiResponse =
  /** status 200  */ BreakDetailRead;
export type SchedulesBreaksRetrieveApiArg = {
  /** A unique integer value identifying this Pause. */
  breakId: number;
};
export type SchedulesBreaksUpdateApiResponse = /** status 200  */ BreakRead;
export type SchedulesBreaksUpdateApiArg = {
  /** A unique integer value identifying this Pause. */
  breakId: number;
  breakRequest: BreakRequest;
};
export type SchedulesBreaksPartialUpdateApiResponse =
  /** status 200  */ BreakRead;
export type SchedulesBreaksPartialUpdateApiArg = {
  /** A unique integer value identifying this Pause. */
  breakId: number;
  patchedBreakRequest: PatchedBreakRequest;
};
export type SchedulesBreaksDestroyApiResponse = unknown;
export type SchedulesBreaksDestroyApiArg = {
  /** A unique integer value identifying this Pause. */
  breakId: number;
};
export type SchedulesBreaksByDayRetrieveApiResponse =
  /** status 200  */ BreakDetailRead;
export type SchedulesBreaksByDayRetrieveApiArg = {
  /** Day of the week (monday, tuesday, etc.) */
  day:
  | "friday"
  | "monday"
  | "saturday"
  | "sun"
  | "thursday"
  | "tuesday"
  | "wednesday";
};
export type SchedulesBreaksBySalonRetrieveApiResponse =
  /** status 200  */ BreakDetailRead;
export type SchedulesBreaksBySalonRetrieveApiArg = {
  /** ID of the salon */
  salonId: number;
};
export type SchedulesBreaksByTeamMemberRetrieveApiResponse =
  /** status 200  */ BreakDetailRead;
export type SchedulesBreaksByTeamMemberRetrieveApiArg = {
  /** ID of the team member */
  teamMemberId: number;
};
export type SchedulesSchedulesListApiResponse =
  /** status 200  */ ScheduleDetailRead[];
export type SchedulesSchedulesListApiArg = void;
export type SchedulesSchedulesCreateApiResponse =
  /** status 201  */ ScheduleRead;
export type SchedulesSchedulesCreateApiArg = {
  scheduleRequest: ScheduleRequest;
};
export type SchedulesSchedulesRetrieveApiResponse =
  /** status 200  */ ScheduleDetailRead;
export type SchedulesSchedulesRetrieveApiArg = {
  /** A unique integer value identifying this schedule. */
  scheduleId: number;
};
export type SchedulesSchedulesUpdateApiResponse =
  /** status 200  */ ScheduleRead;
export type SchedulesSchedulesUpdateApiArg = {
  /** A unique integer value identifying this schedule. */
  scheduleId: number;
  scheduleRequest: ScheduleRequest;
};
export type SchedulesSchedulesPartialUpdateApiResponse =
  /** status 200  */ ScheduleRead;
export type SchedulesSchedulesPartialUpdateApiArg = {
  /** A unique integer value identifying this schedule. */
  scheduleId: number;
  patchedScheduleRequest: PatchedScheduleRequest;
};
export type SchedulesSchedulesDestroyApiResponse = unknown;
export type SchedulesSchedulesDestroyApiArg = {
  /** A unique integer value identifying this schedule. */
  scheduleId: number;
};
export type SchedulesSchedulesByDayRetrieveApiResponse =
  /** status 200  */ ScheduleDetailRead;
export type SchedulesSchedulesByDayRetrieveApiArg = {
  /** Day of the week (monday, tuesday, etc.) */
  day:
  | "friday"
  | "monday"
  | "saturday"
  | "sun"
  | "thursday"
  | "tuesday"
  | "wednesday";
};
export type SchedulesSchedulesBySalonRetrieveApiResponse =
  /** status 200  */ ScheduleDetailRead;
export type SchedulesSchedulesBySalonRetrieveApiArg = {
  /** ID of the salon */
  salonId: number;
};
export type SchedulesSchedulesByTeamMemberRetrieveApiResponse =
  /** status 200  */ ScheduleDetailRead;
export type SchedulesSchedulesByTeamMemberRetrieveApiArg = {
  /** ID of the team member */
  teamMemberId: number;
};
export type ServicesListApiResponse = /** status 200  */ ServiceRead[];
export type ServicesListApiArg = {
  category?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  salon?: number;
  /** A search term. */
  search?: string;
};
export type ServicesCreateApiResponse = /** status 201  */ ServiceRead;
export type ServicesCreateApiArg = {
  body: {
    salon: number;
    category?: number;
    name: string;
    description?: string;
    price: number;
    client_booking_disabled?: boolean;
    duration: number;
    image?: Blob;
    images?: Blob[];
    primary_image_index?: number;
  };
};
export type ServicesRetrieveApiResponse = /** status 200  */ ServiceRead;
export type ServicesRetrieveApiArg = {
  /** A unique integer value identifying this service. */
  serviceId: number;
};
export type ServicesPartialUpdateApiResponse = /** status 200  */ ServiceRead;
export type ServicesPartialUpdateApiArg = {
  /** A unique integer value identifying this service. */
  serviceId: number;
  body: {
    /** Optional */
    category?: number;
    /** Optional */
    name?: string;
    /** Optional */
    description?: string;
    /** Optional */
    price?: number;
    /** Optional */
    client_booking_disabled?: boolean;
    /** Optional */
    duration?: number;
    /** Optional */
    image?: Blob;
    /** Optional, list of image files */
    images?: Blob[];
    /** Optional, index of primary image in images array */
    primary_image_index?: number;
    /** Optional, list of image IDs to remove */
    remove_images?: number[];
    /** Optional, ID of image to set as primary */
    set_primary_image?: number;
  };
};
export type ServicesDestroyApiResponse = /** status 200  */ {
  success?: string;
};
export type ServicesDestroyApiArg = {
  /** A unique integer value identifying this service. */
  serviceId: number;
};
export type ServicesByCategoryListApiResponse =
  /** status 200  */ ServiceListByCategoryRead[];
export type ServicesByCategoryListApiArg = {
  category?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  salon?: number;
  salonId: number;
  /** A search term. */
  search?: string;
};
export type ServicesPublicPublicAllServicesListApiResponse =
  /** status 200  */ ServiceRead[];
export type ServicesPublicPublicAllServicesListApiArg = void;
export type ServicesPublicSalonListApiResponse =
  /** status 200  */ ServiceRead[];
export type ServicesPublicSalonListApiArg = {
  salonId: number;
  language?: string;
};
export type ServicesSalonListApiResponse = /** status 200  */ ServiceRead[];
export type ServicesSalonListApiArg = {
  category?: number;
  /** Which field to use when ordering the results. */
  ordering?: string;
  salon?: number;
  salonId: number;
  /** A search term. */
  search?: string;
  language?: string;
};
export type TeamsTeamMembersListApiResponse =
  /** status 200  */ TeamMemberRead[];
export type TeamsTeamMembersListApiArg = void;
export type TeamsTeamMembersCreateApiResponse =
  /** status 201  */ TeamMemberRead;
export type TeamsTeamMembersCreateApiArg = {
  teamMemberRequest: TeamMemberRequestWrite;
};
export type TeamsTeamMembersRetrieveApiResponse =
  /** status 200  */ TeamMemberDetailRead;
export type TeamsTeamMembersRetrieveApiArg = {
  /** A unique integer value identifying this Team Member. */
  teamMemberId: number;
};
export type TeamsTeamMembersUpdateApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersUpdateApiArg = {
  /** A unique integer value identifying this Team Member. */
  teamMemberId: number;
  teamMemberRequest: TeamMemberRequestWrite;
};
export type TeamsTeamMembersPartialUpdateApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersPartialUpdateApiArg = {
  /** A unique integer value identifying this Team Member. */
  teamMemberId: number;
  patchedTeamMemberRequest: PatchedTeamMemberRequestWrite;
};
export type TeamsTeamMembersDestroyApiResponse = unknown;
export type TeamsTeamMembersDestroyApiArg = {
  /** A unique integer value identifying this Team Member. */
  teamMemberId: number;
};
export type TeamsTeamMembersByServiceSalonRetrieveApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersByServiceSalonRetrieveApiArg = {
  /** Filter by salon ID */
  salon: number;
  /** Filter by service ID */
  service: number;
};
export type TeamsTeamMembersByOwnerRetrieveApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersByOwnerRetrieveApiArg = void;
export type TeamsTeamMembersMemberAppointmentsRetrieveApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersMemberAppointmentsRetrieveApiArg = {
  /** Filter appointments by end date (YYYY-MM-DD) (optional) */
  endDate?: string;
  /** Filter appointments by start date (YYYY-MM-DD) (optional) */
  startDate?: string;
  /** Filter appointments by status (optional) */
  status?: string;
  /** ID of the team member to get appointments for */
  teamMemberId: number;
};
export type TeamsTeamMembersMemberSalonsRetrieveApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersMemberSalonsRetrieveApiArg = {
  /** ID of the team member to get salons for */
  teamMemberId: number;
};
export type TeamsTeamMembersSalonMembersRetrieveApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersSalonMembersRetrieveApiArg = {
  /** ID of the salon to get members for */
  salon: number;
};
export type TeamsTeamMembersUserServicesRetrieveApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersUserServicesRetrieveApiArg = {
  /** ID of the user to get services for */
  userId: number;
};
export type TeamsTeamMembersUserTeamsRetrieveApiResponse =
  /** status 200  */ TeamMemberRead;
export type TeamsTeamMembersUserTeamsRetrieveApiArg = {
  /** ID of the user to get teams for */
  userId: number;
};
export type TeamsTeamsListApiResponse = /** status 200  */ TeamRead[];
export type TeamsTeamsListApiArg = void;
export type TeamsTeamsCreateApiResponse = /** status 201  */ TeamRead;
export type TeamsTeamsCreateApiArg = {
  teamRequest: TeamRequest;
};
export type TeamsTeamsRetrieveApiResponse = /** status 200  */ TeamDetailRead;
export type TeamsTeamsRetrieveApiArg = {
  /** A unique integer value identifying this Team. */
  teamId: number;
};
export type TeamsTeamsUpdateApiResponse = /** status 200  */ TeamRead;
export type TeamsTeamsUpdateApiArg = {
  /** A unique integer value identifying this Team. */
  teamId: number;
  teamRequest: TeamRequest;
};
export type TeamsTeamsPartialUpdateApiResponse = /** status 200  */ TeamRead;
export type TeamsTeamsPartialUpdateApiArg = {
  /** A unique integer value identifying this Team. */
  teamId: number;
  patchedTeamRequest: PatchedTeamRequest;
};
export type TeamsTeamsDestroyApiResponse = unknown;
export type TeamsTeamsDestroyApiArg = {
  /** A unique integer value identifying this Team. */
  teamId: number;
};
export type TeamsTeamsMembersRetrieveApiResponse = /** status 200  */ TeamRead;
export type TeamsTeamsMembersRetrieveApiArg = {
  /** A unique integer value identifying this Team. */
  teamId: number;
};
export type UsersListApiResponse = /** status 200  */ UserRead[];
export type UsersListApiArg = {
  /** Filter users by role */
  role?: string;
};
export type UsersCreateApiResponse = /** status 201  */ UserRead;
export type UsersCreateApiArg = {
  userCreateRequest: UserCreateRequestWrite;
};
export type UsersRetrieveApiResponse = /** status 200  */ UserRead;
export type UsersRetrieveApiArg = {
  /** A unique integer value identifying this user. */
  id: number;
};
export type UsersPartialUpdateApiResponse = /** status 200  */ UserRead;
export type UsersPartialUpdateApiArg = {
  /** A unique integer value identifying this user. */
  id: number;
  patchedUserRequest: PatchedUserRequest;
};
export type UsersDestroyApiResponse = /** status 200  */ {
  success?: string;
};
export type UsersDestroyApiArg = {
  /** A unique integer value identifying this user. */
  id: number;
};
export type UsersClientsListApiResponse = /** status 200  */ UserRead[];
export type UsersClientsListApiArg = {
  /** Filter clients by email (partial match) */
  email?: string;
  /** Filter clients by first name (partial match) */
  firstName?: string;
  /** Filter clients by last name (partial match) */
  lastName?: string;
  /** Filter clients by phone number (partial match) */
  phone?: string;
  /** General search term to filter clients by first name, last name, or email */
  search?: string;
};
export type UsersClientsByOwnerListApiResponse = /** status 200  */ UserRead[];
export type UsersClientsByOwnerListApiArg = {
  /** Filter clients by email (partial match) */
  email?: string;
  /** Filter clients by first name (partial match) */
  firstName?: string;
  /** Filter clients by last name (partial match) */
  lastName?: string;
  /** Owner user ID (required). */
  ownerId: number;
  /** Filter clients by phone number (partial match) */
  phone?: string;
  /** General search term to filter clients by first name, last name, or email */
  search?: string;
};
export type UsersClientsBySalonListApiResponse = /** status 200  */ UserRead[];
export type UsersClientsBySalonListApiArg = {
  /** Filter clients by email (partial match) */
  email?: string;
  /** Filter clients by first name (partial match) */
  firstName?: string;
  /** Filter clients by last name (partial match) */
  lastName?: string;
  /** Filter clients by phone number (partial match) */
  phone?: string;
  /** The salon ID to filter clients by */
  salonId: number;
  /** General search term to filter clients by first name, last name, or email */
  search?: string;
};
export type UsersNotifyClientsCreateApiResponse = /** status 200  */ {
  success: boolean;
  email_sent: number;
  notifications_created: number;
  total_clients: number;
  errors: string[];
};
export type UsersNotifyClientsCreateApiArg = {
  clientIds: number[];
  deliveryModes: string[]; // ['email', 'notification']
  emailSubject?: string;
  emailContent?: string;
  notificationTitle?: string;
  notificationMessage?: string;
  photo?: File;
};
export type StatusEnum = "pending" | "confirmed" | "cancelled" | "completed";
export type AppointmentList = {
  start_time: string;
  end_time?: string | null;
  status?: StatusEnum;
  cancellation_reason?: string | null;
};
export type AppointmentListRead = {
  appointment_id: number;
  salon_name: string;
  client_name: string;
  team_member_name: string;
  service_name: string;
  start_time: string;
  end_time?: string | null;
  status?: StatusEnum;
  cancellation_reason?: string | null;
};
export type AppointmentCreate = {
  salon: number;
  client?: number | null;
  team_member?: number | null;
  service?: number | null;
  start_time: string;
  end_time?: string | null;
  status?: StatusEnum;
  cancellation_reason?: string | null;
};
export type AppointmentCreateRequest = {
  salon: number;
  client?: number | null;
  team_member?: number | null;
  service?: number | null;
  start_time: string;
  end_time?: string | null;
  status?: StatusEnum;
  cancellation_reason?: string | null;
};
export type AppointmentUpdate = {
  team_member?: number | null;
  service?: number | null;
  start_time: string;
  end_time?: string | null;
  status?: StatusEnum;
  cancellation_reason?: string | null;
};
export type AppointmentUpdateRequest = {
  team_member?: number | null;
  service?: number | null;
  start_time: string;
  end_time?: string | null;
  status?: StatusEnum;
  cancellation_reason?: string | null;
};
export type PatchedAppointmentUpdateRequest = {
  team_member?: number | null;
  service?: number | null;
  start_time?: string;
  end_time?: string | null;
  status?: StatusEnum;
  cancellation_reason?: string | null;
};
export type SimpleClient = {
  first_name: string;
  last_name: string;
  phone?: string | null;
  email?: string | null;
};
export type SimpleClientRead = {
  id: number;
  first_name: string;
  last_name: string;
  phone?: string | null;
  email?: string | null;
};
export type SimpleClientRequest = {
  first_name: string;
  last_name: string;
  phone?: string | null;
  email?: string | null;
};
export type ChangePasswordRequest = {
  old_password: string;
  new_password: string;
  confirm_password: string;
};
export type LoginRequest = {
  email: string;
};
export type LoginRequestWrite = {
  email: string;
  password: string;
};
export type RequestPasswordResetRequest = {
  email: string;
};
export type UserPermissions = {
  permissions: string[];
};
export type User = {
  first_name: string;
  last_name: string;
  phone?: string | null;
};
export type RoleEnum =
  | "client"
  | "professional_responsable"
  | "professional_employe"
  | "superadmin";
export type UserRead = {
  id: number;
  email: string | null;
  first_name: string;
  last_name: string;
  phone?: string | null;
  role: RoleEnum;
};
export type UserRequest = {
  first_name: string;
  last_name: string;
  phone?: string | null;
};
export type RegisterRequest = {
  email?: string | null;
  first_name: string;
  last_name: string;
  phone?: string | null;
  role?: RoleEnum;
};
export type RegisterRequestWrite = {
  email?: string | null;
  first_name: string;
  last_name: string;
  phone?: string | null;
  role?: RoleEnum;
  password: string;
  password_confirm: string;
};
export type ResetPasswordRequest = {
  password: string;
  confirm_password: string;
};
export type CustomTokenObtainPairRequest = {};
export type CustomTokenObtainPairRequestWrite = {
  email: string;
  password: string;
};
export type TokenRefresh = {};
export type TokenRefreshRead = {
  access: string;
};
export type TokenRefreshRequest = {};
export type TokenRefreshRequestWrite = {
  refresh: string;
};
export type Category = {
  salon?: number | null;
  name: string;
  description?: string;
};
export type CategoryRead = {
  category_id: number;
  salon?: number | null;
  salon_name: string;
  name: string;
  description?: string;
  created_at: string;
  updated_at: string;
};
export type CategoryCreateRequest = {
  salon?: number | null;
  name: string;
  description?: string;
};
export type GlobalDashboard = {
  total_revenue: string;
  total_appointments: number;
  active_salons: number;
  total_employees: number;
  global_performance: string;
  salon_performances: {
    [key: string]: any;
  }[];
  monthly_revenue: string;
  popular_services: {
    [key: string]: any;
  }[];
  today_appointments: {
    [key: string]: any;
  }[];
};
export type DashboardMetric = {
  salon: number;
  date: string;
  revenue?: string;
  appointments_count?: number;
  appointments_confirmed?: number;
  appointments_waiting?: number;
  clients_count?: number;
  occupation_rate?: string;
};
export type DashboardMetricRead = {
  metric_id: number;
  salon: number;
  salon_name: string;
  date: string;
  revenue?: string;
  appointments_count?: number;
  appointments_confirmed?: number;
  appointments_waiting?: number;
  clients_count?: number;
  occupation_rate?: string;
};
export type DashboardMetricRequest = {
  salon: number;
  date: string;
  revenue?: string;
  appointments_count?: number;
  appointments_confirmed?: number;
  appointments_waiting?: number;
  clients_count?: number;
  occupation_rate?: string;
};
export type PatchedDashboardMetricRequest = {
  salon?: number;
  date?: string;
  revenue?: string;
  appointments_count?: number;
  appointments_confirmed?: number;
  appointments_waiting?: number;
  clients_count?: number;
  occupation_rate?: string;
};
export type SalonDashboard = {};
export type Salon = {
  owner: number;
  name: string;
  description?: string;
  phone?: string;
  email?: string;
  opening_hours?: {
    [key: string]: any;
  } | null;
  photos?: {
    [key: string]: any;
  };
};
export type SalonRead = {
  salon_id: number;
  owner: number;
  name: string;
  description?: string;
  phone?: string;
  email?: string;
  opening_hours?: {
    [key: string]: any;
  } | null;
  photos?: {
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
  latitude: string;
  longitude: string;
  formatted_address: string;
};
export type ServicePopularity = {
  salon: number;
  service_name: string;
  count?: number;
  percentage?: string;
  month: number;
  year: number;
};
export type ServicePopularityRead = {
  popularity_id: number;
  salon: number;
  salon_name: string;
  service_name: string;
  count?: number;
  percentage?: string;
  month: number;
  year: number;
};
export type MonthlySalonPerformance = {
  salon: number;
  month: number;
  year: number;
  monthly_revenue?: string;
  monthly_target?: string;
  percentage_of_target?: string;
  growth_from_previous?: string;
};
export type MonthlySalonPerformanceRead = {
  performance_id: number;
  salon: number;
  salon_name: string;
  month: number;
  year: number;
  monthly_revenue?: string;
  monthly_target?: string;
  percentage_of_target?: string;
  growth_from_previous?: string;
};
export type SalonDashboardRead = {
  salon: SalonRead;
  today_metrics: DashboardMetricRead;
  popular_services: ServicePopularityRead[];
  monthly_performance: MonthlySalonPerformanceRead;
};
export type Location = {
  salon: number;
  latitude: string;
  longitude: string;
};
export type LocationRead = {
  location_id: number;
  salon: number;
  latitude: string;
  longitude: string;
  formatted_address: string;
  created_at: string;
};
export type LocationCreate = {
  salon: number;
  latitude: string;
  longitude: string;
  formatted_address?: string | null;
};
export type LocationCreateRequest = {
  salon: number;
  latitude: string;
  longitude: string;
  formatted_address?: string | null;
};
export type LocationUpdate = {
  latitude?: string;
  longitude?: string;
  formatted_address?: string | null;
};
export type PatchedLocationUpdateRequest = {
  latitude?: string;
  longitude?: string;
  formatted_address?: string | null;
};
export type DayOfWeekEnum =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sun";
export type BreakDetail = {
  day_of_week: DayOfWeekEnum;
  start_time: string;
  end_time: string;
  /** Description de la pause (ex: Déjeuner, Pause café) */
  description?: string | null;
};
export type TeamMember = {
  team?: number;
  team_ids?: number[];
  user?: number;
  service_ids?: number[];
  salon?: number;
};
export type TeamMemberRead = {
  team_member_id: number;
  team?: number;
  team_ids?: number[];
  team_name: string;
  team_details: string;
  user?: number;
  user_details: string;
  service_ids?: number[];
  service_names: string;
  salon?: number;
  salon_id: string;
  salon_name: string;
};
export type BreakDetailRead = {
  break_id: number;
  team_member: TeamMemberRead;
  salon: SalonRead;
  day_of_week: DayOfWeekEnum;
  start_time: string;
  end_time: string;
  /** Description de la pause (ex: Déjeuner, Pause café) */
  description?: string | null;
};
export type Break = {
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
  description?: string | null;
};
export type BreakRead = {
  break_id: number;
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
  description?: string | null;
};
export type BreakRequest = {
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
  description?: string | null;
};
export type PatchedBreakRequest = {
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
  description?: string | null;
};
export type ScheduleDetail = {
  day_of_week: DayOfWeekEnum;
  start_time: string;
  end_time: string;
};
export type ScheduleDetailRead = {
  schedule_id: number;
  team_member: TeamMemberRead;
  salon: SalonRead;
  day_of_week: DayOfWeekEnum;
  start_time: string;
  end_time: string;
};
export type Schedule = {
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
};
export type ScheduleRead = {
  schedule_id: number;
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
};
export type ScheduleRequest = {
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
};
export type PatchedScheduleRequest = {
  team_member?: number;
  salon?: number;
  day_of_week?: string;
  start_time?: string;
  end_time?: string;
};
export type Service = {
  salon: number;
  category?: number | null;
  name: string;
  description?: string;
  price: string;
  client_booking_disabled?: boolean;
  /** Duration in minutes */
  duration: number;
  image?: string | null;
};
export type ServiceImage = {
  service: number;
  image: string;
  is_primary?: boolean;
};
export type ServiceImageRead = {
  image_id: number;
  service: number;
  image: string;
  image_url: string;
  is_primary?: boolean;
  created_at: string;
};
export type ServiceRead = {
  service_id: number;
  salon: number;
  category?: number | null;
  category_details: CategoryRead;
  name: string;
  description?: string;
  price: string;
  client_booking_disabled?: boolean;
  /** Duration in minutes */
  duration: number;
  formatted_duration: string;
  image?: string | null;
  image_url: string;
  images: ServiceImageRead[];
  has_assigned_employees?: boolean;
  created_at: string;
  updated_at: string;
};
export type ServiceListByCategory = {
  name: string;
  description?: string;
  price: string;
  client_booking_disabled?: boolean;
  /** Duration in minutes */
  duration: number;
};
export type ServiceListByCategoryRead = {
  service_id: number;
  name: string;
  description?: string;
  price: string;
  client_booking_disabled?: boolean;
  /** Duration in minutes */
  duration: number;
  formatted_duration: string;
  image_url: string;
};
export type TeamMemberRequest = {
  team?: number;
  team_ids?: number[];
  user?: number;
  service_ids?: number[];
  salon?: number;
};
export type TeamMemberRequestWrite = {
  team?: number;
  team_ids?: number[];
  user?: number;
  service_ids?: number[];
  email?: string;
  first_name?: string;
  last_name?: string;
  phone?: string | null;
  password?: string;
  salon?: number;
};
export type TeamMemberDetail = {
  team?: number | null;
};
export type TeamMemberDetailRead = {
  team_member_id: number;
  team?: number | null;
  team_name: string;
  user: string;
  services: string[];
};
export type PatchedTeamMemberRequest = {
  team?: number;
  team_ids?: number[];
  user?: number;
  service_ids?: number[];
  salon?: number;
};
export type PatchedTeamMemberRequestWrite = {
  team?: number;
  team_ids?: number[];
  user?: number;
  service_ids?: number[];
  email?: string;
  first_name?: string;
  last_name?: string;
  phone?: string | null;
  password?: string;
  salon?: number;
};
export type Team = {
  salon: number;
  name: string;
  description?: string;
};
export type TeamRead = {
  team_id: number;
  salon: number;
  salon_info: string;
  salon_name: string;
  name: string;
  description?: string;
};
export type TeamRequest = {
  salon: number;
  name: string;
  description?: string;
};
export type TeamDetail = {
  salon: number;
  name: string;
  description?: string;
};
export type TeamDetailRead = {
  team_id: number;
  salon: number;
  salon_name: string;
  name: string;
  description?: string;
  members_count: string;
};
export type PatchedTeamRequest = {
  salon?: number;
  name?: string;
  description?: string;
};
export type UserCreateRequest = {
  email?: string | null;
  first_name: string;
  last_name: string;
  phone?: string | null;
  role?: RoleEnum;
};
export type UserCreateRequestWrite = {
  email?: string | null;
  password: string;
  first_name: string;
  last_name: string;
  phone?: string | null;
  role?: RoleEnum;
};
export type PatchedUserRequest = {
  email?: string | null;
  first_name?: string;
  last_name?: string;
  phone?: string | null;
  role?: RoleEnum;
};
export const {
  useAppointmentsListQuery,
  useAppointmentsCreateMutation,
  useAppointmentsRetrieveQuery,
  useAppointmentsUpdateMutation,
  useAppointmentsPartialUpdateMutation,
  useAppointmentsDestroyMutation,
  useAppointmentsAvailableSlotsRetrieveQuery,
  useAppointmentsConsecutiveSlotsRetrieveQuery,
  useAppointmentsMultiConsecutiveSlotsCreateMutation,
  useAppointmentsUpcomingRetrieveQuery,
  useAuthAddclientCreateMutation,
  useAuthChangePasswordCreateMutation,
  useAuthLoginCreateMutation,
  useAuthLoginClientCreateMutation,
  useAuthLoginProfessionalResponsableCreateMutation,
  useAuthLogoutCreateMutation,
  useAuthPasswordResetCreateMutation,
  useAuthPermissionsRetrieveQuery,
  useAuthProfileRetrieveQuery,
  useAuthProfileUpdateMutation,
  useAuthRegisterCreateMutation,
  useAuthRegisterClientCreateMutation,
  useAuthRegisterProfessionalResponsableCreateMutation,
  useAuthResetPasswordCreateMutation,
  useAuthTokenCreateMutation,
  useAuthTokenRefreshCreateMutation,
  useCategoriesListQuery,
  useCategoriesCreateMutation,
  useCategoriesRetrieveQuery,
  useCategoriesPartialUpdateMutation,
  useCategoriesDestroyMutation,
  useCategoriesDefaultRetrieveQuery,
  useDashboardGlobalRetrieveQuery,
  useDashboardMetricsListQuery,
  useDashboardMetricsCreateMutation,
  useDashboardMetricsRetrieveQuery,
  useDashboardMetricsUpdateMutation,
  useDashboardMetricsPartialUpdateMutation,
  useDashboardMetricsDestroyMutation,
  useDashboardSalonRetrieveQuery,
  useLocationsListQuery,
  useLocationsCreateMutation,
  useLocationsRetrieveQuery,
  useLocationsPartialUpdateMutation,
  useLocationsDestroyMutation,
  useSalonsListQuery,
  useSalonsCreateMutation,
  useSalonsRetrieveQuery,
  useSalonsPartialUpdateMutation,
  useSalonsDestroyMutation,
  useSalonsCategoriesListQuery,
  useSalonsMySalonsRetrieveQuery,
  useSalonsSearchSalonsListQuery,
  useSchedulesBreaksListQuery,
  useSchedulesBreaksCreateMutation,
  useSchedulesBreaksRetrieveQuery,
  useSchedulesBreaksUpdateMutation,
  useSchedulesBreaksPartialUpdateMutation,
  useSchedulesBreaksDestroyMutation,
  useSchedulesBreaksByDayRetrieveQuery,
  useSchedulesBreaksBySalonRetrieveQuery,
  useSchedulesBreaksByTeamMemberRetrieveQuery,
  useSchedulesSchedulesListQuery,
  useSchedulesSchedulesCreateMutation,
  useSchedulesSchedulesRetrieveQuery,
  useSchedulesSchedulesUpdateMutation,
  useSchedulesSchedulesPartialUpdateMutation,
  useSchedulesSchedulesDestroyMutation,
  useSchedulesSchedulesByDayRetrieveQuery,
  useSchedulesSchedulesBySalonRetrieveQuery,
  useSchedulesSchedulesByTeamMemberRetrieveQuery,
  useServicesListQuery,
  useServicesCreateMutation,
  useServicesRetrieveQuery,
  useServicesPartialUpdateMutation,
  useServicesDestroyMutation,
  useServicesByCategoryListQuery,
  useServicesPublicPublicAllServicesListQuery,
  useServicesPublicSalonListQuery,
  useServicesSalonListQuery,
  useTeamsTeamMembersListQuery,
  useTeamsTeamMembersCreateMutation,
  useTeamsTeamMembersRetrieveQuery,
  useTeamsTeamMembersUpdateMutation,
  useTeamsTeamMembersPartialUpdateMutation,
  useTeamsTeamMembersDestroyMutation,
  useTeamsTeamMembersByServiceSalonRetrieveQuery,
  useTeamsTeamMembersByOwnerRetrieveQuery,
  useTeamsTeamMembersMemberAppointmentsRetrieveQuery,
  useTeamsTeamMembersMemberSalonsRetrieveQuery,
  useTeamsTeamMembersSalonMembersRetrieveQuery,
  useTeamsTeamMembersUserServicesRetrieveQuery,
  useTeamsTeamMembersUserTeamsRetrieveQuery,
  useTeamsTeamsListQuery,
  useTeamsTeamsCreateMutation,
  useTeamsTeamsRetrieveQuery,
  useTeamsTeamsUpdateMutation,
  useTeamsTeamsPartialUpdateMutation,
  useTeamsTeamsDestroyMutation,
  useTeamsTeamsMembersRetrieveQuery,
  useUsersListQuery,
  useUsersCreateMutation,
  useUsersRetrieveQuery,
  useUsersPartialUpdateMutation,
  useUsersDestroyMutation,
  useUsersClientsListQuery,
  useUsersClientsByOwnerListQuery,
  useUsersClientsBySalonListQuery,
  useUsersNotifyClientsCreateMutation,
} = injectedRtkApi;
